import { Scene } from "phaser";
import { getResolution } from "../lib/config";

export class GameOver extends Scene {
  camera: Phaser.Cameras.Scene2D.Camera;
  background: Phaser.GameObjects.Image;
  gameover_text: Phaser.GameObjects.Text;
  restartBtn: Phaser.GameObjects.Image;
  seagull: Phaser.GameObjects.Image;
  logoExplora: Phaser.GameObjects.Image;

  constructor() {
    super("GameOver");
  }

  create() {
    const resolution: any = getResolution();
    this.camera = this.cameras.main;

    this.background = this.add.image(
      resolution.width / 2,
      resolution.height / 2,
      "endbg"
    );

    this.gameover_text = this.add.text(
      resolution.width * 0.77,
      resolution.height * 0.15,
      `Este es la historia de un viaje para entender la
vida, las respuestas pendientes y, en todo caso
y por siempre, su complejidad y su belleza.
Hasta ese momento no habían nacido aún
conceptos como la ecología o la genética.
Este es, entonces, el relato de una revolución.`,
      {
        fontFamily: "Arial bold",
        fontSize: 38,
        fontStyle: "italic",
        color: "#000000",
        align: "right",
      }
    );
    this.gameover_text.setOrigin(0.5);

    this.seagull = this.add.image(290, 300, "seagull");
    this.logoExplora = this.add.image(
      250,
      resolution.height * 0.9,
      "logoexplora"
    );
    // Restart Button
    this.restartBtn = this.add
      .image(resolution.width * 0.8, resolution.height * 0.75, "restartBtnOff")
      .setInteractive();
    this.restartBtn.on("pointerover", () =>
      this.restartBtn.setTexture("restartBtnOn")
    );
    this.restartBtn.on("pointerout", () => {
      this.restartBtn.setTexture("restartBtnOff");
    });
    this.restartBtn.on("pointerdown", () => {
      location.reload();
      /* this.scene.start("Game").start("HUD").remove(); */
    });
  }
}
